import type { IGLMenuItem } from '@group-link-one/gl-components';
import { GLIcon } from '@group-link-one/gl-icons';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MainRoutes } from '../enums/enums';
import { useGetTopbarAddonsItems } from './useGetTopbarAddonsItems';
import { useMainLayoutTranslate } from './useMainLayoutTranslate';
import { usePrivileges } from '@/hooks/usePrivilleges';
import { verifyIfPathIsActives } from '@/utils/verifyIfPathIsActive';

export const useNavListBottom = () => {
  const navigate = useNavigate();
  const { pages } = usePrivileges();
  const { settings } = useGetTopbarAddonsItems();
  const { customLocale } = useMainLayoutTranslate();

  const settingsIsToAppear = useMemo(
    () => pages.settings.overview || pages.settings.myAccount || pages.settings.loginSecurity,
    [pages.settings],
  );

  const navListBottom: IGLMenuItem[] = useMemo(() => {
    const items: IGLMenuItem[] = [
      {
        id: 'settings',
        icon: <GLIcon variant='Settings.Gear' />,
        label: customLocale('main.settings', 'Settings'),
        active: verifyIfPathIsActives(MainRoutes.SETTINGS),
        isToAppear: settingsIsToAppear,
        dropdown: false,
        items: settings,
        onClick: () => navigate(MainRoutes.SETTINGS),
      },
    ];

    return items;
  }, [settings, settingsIsToAppear, customLocale, navigate]);

  return { navListBottom };
};
